import React from 'react';
import { Typography } from '@mui/material';
import { Popup } from 'react-map-gl';

import { PopupContent } from './PopupContent';
import { WalkabilityFeature } from '../../types/WalkabilityFeature';
import { getCenter } from '../services/GetCenter';

type WalkabilityPopupProps = {
  feature?: WalkabilityFeature;
  onClose: () => void;
};

export const WalkabilityPopup = ({ feature, onClose }: WalkabilityPopupProps) => {
  if (!feature) {
    return null;
  }

  const [poly] = feature.geometry.coordinates;
  const { id, index } = feature.properties;
  const center = getCenter(poly);

  return (
    <Popup
      key={`${String(id)}:${index}`}
      longitude={center[0]}
      latitude={center[1]}
      onClose={onClose}
      offset={0}
      maxWidth="min(480px, 75vw)"
      closeButton={false}
    >
      <PopupContent onClose={onClose}>
        <Typography fontWeight="bold" color="text.primary" mb={1} sx={{ fontSize: '1rem' }}>
          Walkability
        </Typography>
        <Typography color="text.primary" mb={1}>
          {index}
        </Typography>
      </PopupContent>
    </Popup>
  );
};
